import { MULTIPLE_TYPE } from 'common/constants/process-management';
import { Question } from 'dashboard409a/pages/Information/types';

export const extractAnswer = (question: Question) => {
  const { answers } = question;
  if (question.question_type !== MULTIPLE_TYPE && answers?.length > 0) {
    return answers[0];
  }

  return null;
};
